<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <!-- <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs> -->
        <v-tabs v-model="tabs" lift>
          <v-tabs-slider color="yellow"></v-tabs-slider>

          <v-tab href="#tabInfo">ภาพรวม</v-tab>
          <v-tab href="#team">ทีม</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabs">
          <v-tab-item value="tabInfo">
            <v-card flat>
              <v-row>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="6">
                      <v-sheet tile height="54" class="d-flex">
                        <v-select
                          v-model="month"
                          :items="monthNameTH"
                          dense
                          outlined
                          hide-details
                          label="เดือน"
                          class="ma-2"
                        ></v-select>
                        <v-select
                          v-model="year"
                          :items="yearsNumber"
                          dense
                          outlined
                          hide-details
                          label="ปี"
                          class="ma-2"
                        ></v-select>
                        <v-icon
                          color="#262A34"
                          size="50"
                          @click="
                            getDataToday(), getCalendar(), getReportCheckIN()
                          "
                          >mdi-card-search</v-icon
                        >
                      </v-sheet>
                    </v-col>
                  </v-row>
                  <v-card>
                    <v-row>
                      <v-col cols="3">
                        <v-card elevation="12" height="1350px">
                          <center>
                            <v-toolbar color="#B61C1C" dark>
                              <v-toolbar-title>
                                <v-icon color="whire"
                                  >mdi-account-circle</v-icon
                                >
                                ข้อมูล</v-toolbar-title
                              >
                            </v-toolbar>
                            <center>
                              <v-avatar
                                class="profile"
                                style="margin-top: 10px"
                                color="grey"
                                size="150"
                                rounded
                              >
                                <v-img
                                  v-if="profile.empImageUrl"
                                  :src="profile.empImageUrl"
                                ></v-img> </v-avatar
                              ><br />
                            </center>
                            <br />
                            <v-btn
                              class="ma-2"
                              outlined
                              color="#B61C1C"
                              small
                              @click="nextPage()"
                            >
                              <v-icon>mdi-pencil</v-icon>
                              แก้ไขข้อมูลส่วนตัว
                            </v-btn>
                          </center>
                          <v-col>
                            <v-card-text
                              ><v-icon color="#871B12"
                                >mdi-account-circle</v-icon
                              ><strong>ชื่อ-นามสกุล: </strong
                              >{{ profile.empFull_NameTH }}
                            </v-card-text>
                            <v-card-text>
                              <v-icon color="#871B12">mdi-briefcase</v-icon>
                              <strong>หน่วยงาน: </strong
                              >{{ profile.masDepartmentName }}
                            </v-card-text>
                            <v-card-text>
                              <v-icon color="#871B12"
                                >mdi-map-marker-radius</v-icon
                              >
                              <strong>สาขา : </strong
                              >{{ profile.masBranchName }}
                            </v-card-text>
                            <v-card-text
                              ><v-icon color="#871B12">mdi-account-box</v-icon
                              ><strong>รหัสพนักงาน : </strong
                              >{{ profile.empCode }}</v-card-text
                            >
                            <v-card-text
                              ><v-icon color="#871B12">
                                mdi-cellphone-basic </v-icon
                              ><strong>เบอร์โทรศัพท์ : </strong
                              >{{ profile.empTel }}</v-card-text
                            >
                            <v-card-text
                              ><v-icon color="#871B12"> mdi-email </v-icon
                              ><strong>อีเมล์ : </strong>{{ profile.empEmail }}
                            </v-card-text>
                            <v-divider class="mx-4"></v-divider>
                            <v-card-subtitle
                              >รายงานสถานะเข้าออกงานประจำเดือน</v-card-subtitle
                            >
                            <v-card-text
                              ><v-icon color="#871B12"> mdi-calendar </v-icon
                              >จำนวนวันทำงาน :
                              <strong>{{ dataReportMonth.Normal }}</strong> วัน
                            </v-card-text>
                            <v-card-text
                              ><v-icon color="#871B12">
                                mdi-calendar-check </v-icon
                              >จำนวนวันที่เข้างานตามกะ :<strong>{{
                                dataReportMonth.Actual
                              }}</strong
                              >วัน
                            </v-card-text>
                            <v-card-text
                              ><v-icon color="#871B12"> mdi-clock-alert </v-icon
                              >รวมเวลาสาย :
                              <strong>{{ dataReportMonth.Late }}</strong> นาที
                            </v-card-text>
                            <v-card-text
                              ><v-icon color="#871B12">mdi-clock-alert </v-icon
                              >รวมเวลาออกงานก่อนเวลา :
                              <strong>{{ dataReportMonth.Early }}</strong> นาที
                            </v-card-text>
                            <v-card-text
                              ><v-icon color="#871B12">
                                mdi-map-marker-remove-variant </v-icon
                              >ไม่มี Check OUT :
                              <strong>{{ dataReportMonth.absent1 }}</strong
                              >วัน
                            </v-card-text>
                            <v-card-text
                              ><v-icon color="#871B12">
                                mdi-map-marker-remove-variant </v-icon
                              >No Check OUT :
                              <strong>{{ dataReportMonth.absent2 }}</strong
                              >ไม่มี Check IN OUT
                            </v-card-text>
                            <v-divider class="mx-4"></v-divider>
                            <v-card-subtitle
                              >สถานะประเมินโควิดประจำวัน</v-card-subtitle
                            >
                            <v-card-text
                              ><v-icon color="#871B12"> mdi-radioactive </v-icon
                              ><strong>ประเมินความเสี่ยง COVID-19 : </strong
                              ><v-chip
                                v-if="colorRisk === 'สีเขียว'"
                                class="ma-2"
                                color="green"
                                text-color="white"
                              >
                                {{ colorRisk }}
                              </v-chip>
                              <v-chip
                                v-if="colorRisk === 'สีเหลือง'"
                                class="ma-2"
                                color="yellow"
                                text-color="black"
                              >
                                {{ colorRisk }}
                              </v-chip>
                              <v-chip
                                v-if="colorRisk === 'สีส้ม'"
                                class="ma-2"
                                color="orange"
                                text-color="black"
                              >
                                {{ colorRisk }}
                              </v-chip>
                              <v-chip
                                v-if="colorRisk === 'สีแดง'"
                                class="ma-2"
                                color="red"
                                text-color="white"
                              >
                                {{ colorRisk }}
                              </v-chip>
                              <v-chip
                                v-if="!colorRisk"
                                class="ma-2"
                                text-color="black"
                              >
                                ไม่พบข้อมูล
                              </v-chip>
                            </v-card-text>
                          </v-col>
                        </v-card>
                      </v-col>
                      <v-col cols="9">
                        <v-card elevation="12">
                          <v-simple-table fixed-header height="1350px">
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th
                                    class="text-center white--text"
                                    style="background-color: #262a34"
                                  >
                                    วัน/เดือน/ปี
                                  </th>
                                  <th
                                    class="text-center white--text"
                                    style="background-color: #262a34"
                                  >
                                    เวลาเข้างาน
                                  </th>
                                  <th
                                    class="text-center white--text"
                                    style="background-color: #262a34"
                                  >
                                    ระยะทาง (KM)
                                  </th>
                                  <th
                                    class="text-center white--text"
                                    style="background-color: #262a34"
                                  >
                                    เวลาเลิกงาน
                                  </th>
                                  <th
                                    class="text-center white--text"
                                    style="background-color: #262a34"
                                  >
                                    ระยะทาง (KM)
                                  </th>
                                  <th
                                    class="text-center white--text"
                                    style="background-color: #262a34"
                                  >
                                    เวลาสาย
                                  </th>
                                   <th
                                    class="text-center white--text"
                                    style="background-color: #262a34"
                                  >
                                    เวลาประเมิน
                                  </th>
                                  <th
                                    class="text-center white--text"
                                    style="background-color: #262a34"
                                  >
                                    สี
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(items1, index1) in dataItem"
                                  :key="index1"
                                >
                                  <td class="text-center">
                                    {{ items1.shiftDay }}/{{
                                      items1.shiftMonth
                                    }}/{{ items1.shiftYear }}
                                  </td>
                                  <td class="text-center">
                                    <v-chip
                                      class="ma-2"
                                      :color="items1.colorin"
                                      text-color="white"
                                      label
                                    >
                                      {{ items1.checkInStartStamp }}
                                    </v-chip>
                                  </td>
                                  <td class="text-center">
                                    <v-chip
                                      class="ma-2"
                                      :color="items1.colorin"
                                      text-color="white"
                                      label
                                    >
                                      {{ items1.checkInDistance }}
                                    </v-chip>
                                  </td>
                                  <td class="text-center">
                                    <v-chip
                                      class="ma-2"
                                      :color="items1.colorout"
                                      v-if="items1.checkInEndStamp"
                                      text-color="white"
                                      label
                                    >
                                      {{ items1.checkInEndStamp }}
                                    </v-chip>
                                  </td>
                                  <td class="text-center">
                                    <v-chip
                                      class="ma-2"
                                      :color="items1.colorout"
                                      v-if="items1.checkOutDistance"
                                      text-color="white"
                                      label
                                    >
                                      {{ items1.checkOutDistance }}
                                    </v-chip>
                                  </td>
                                  <td class="text-center">
                                    <v-chip
                                      class="ma-2"
                                      text-color="white"
                                      label
                                      color="red"
                                      v-if="
                                        items1.lateTime !== '00:00' &&
                                        items1.lateTime
                                      "
                                    >
                                      {{ items1.lateTime }}
                                    </v-chip>
                                    <v-chip
                                      class="ma-2"
                                      text-color="white"
                                      label
                                      color="green"
                                      v-if="items1.lateTime === '00:00'"
                                    >
                                      {{ items1.lateTime }}
                                    </v-chip>
                                    <v-chip
                                      class="ma-2"
                                      text-color="white"
                                      label
                                      v-if="!items1.lateTime"
                                    >
                                      ไม่พบข้อมูล
                                    </v-chip>
                                  </td>
                                  <td v-if="items1.time_as" class="text-center">
                                    {{ items1.time_as }}
                                  </td>
                                  <td v-if="!items1.time_as" class="text-center">
                                    <v-chip class="ma-2" label>
                                      ไม่พบข้อมูล
                                    </v-chip>
                                  </td>
                                  <td class="text-center">
                                    <v-chip
                                      v-if="items1.color === 'สีเขียว'"
                                      class="ma-2"
                                      color="green"
                                      text-color="white"
                                      label
                                    >
                                      {{ items1.color }}
                                    </v-chip>
                                    <v-chip
                                      v-if="items1.color === 'สีเหลือง'"
                                      class="ma-2"
                                      color="yellow"
                                      text-color="black"
                                      label
                                    >
                                      {{ items1.color }}
                                    </v-chip>
                                    <v-chip
                                      v-if="items1.color === 'สีส้ม'"
                                      class="ma-2"
                                      color="orange"
                                      text-color="black"
                                      label
                                    >
                                      {{ items1.color }}
                                    </v-chip>
                                    <v-chip
                                      v-if="items1.color === 'สีแดง'"
                                      class="ma-2"
                                      color="red"
                                      text-color="black"
                                      label
                                    >
                                      {{ items1.color }}
                                    </v-chip>
                                    <v-chip
                                      class="ma-2"
                                      v-if="!items1.color"
                                      label
                                    >
                                      ไม่พบข้อมูล
                                    </v-chip>
                                  </td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </v-card>
                      </v-col>
                      <v-divider class="mx-4"></v-divider>
                    </v-row>
                  </v-card>
                  <!-- <v-row>
                    <v-col cols="12">
                      <v-expansion-panels v-model="panel" multiple>
                        <v-expansion-panel>
                          <v-expansion-panel-header
                            >ปฏิทิน</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <v-sheet height="500">
                              <v-calendar :start="startdate" :events="events">
                              </v-calendar>
                            </v-sheet>
                          </v-expansion-panel-content>
                        </v-expansion-panel> -->

                  <!-- <v-expansion-panel>
                          <v-expansion-panel-header
                            >แผนที่</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <v-card>
                              <v-col>
                                <GmapMap
                                  :center="center"
                                  map-type-id="terrain"
                                  ref="mapRef"
                                  :zoom="12"
                                  style="width: 100%; height: 600px"
                                  :options="{ disableDefaultUI: true }"
                                >
                                  <GmapMarker :position="center" />
                                  <GmapMarker
                                    v-for="(
                                      m, indexMap1
                                    ) in dataByEmp.shifttemMapCheckIn"
                                    :key="indexMap1"
                                    :position="m.positionIn"
                                    :clickable="true"
                                    :icon="m.iconIn"
                                    @click="openWindows(m)"
                                  />
                                  <GmapMarker
                                    v-for="(
                                      m2, indexMap2
                                    ) in dataByEmp.shifttemMapCheckout"
                                    :key="indexMap2 + 'M2'"
                                    :position="m2.positionOut"
                                    :clickable="true"
                                    :icon="m2.iconOut"
                                    @click="openWindows2(m2)"
                                  />
                                </GmapMap>
                              </v-col>
                            </v-card>
                          </v-expansion-panel-content>
                        </v-expansion-panel> -->
                  <!-- </v-expansion-panels>
                    </v-col>
                  </v-row> -->
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item value="team">
            <v-card flat>
              <v-row>
                <v-col cols="4" v-if="dataItemHeader.empFull_NameTH">
                  <v-card elevation="2">
                    <v-toolbar color="red" dark>
                      <v-toolbar-title>หัวหน้างาน</v-toolbar-title>
                    </v-toolbar>
                    <center>
                      <v-avatar
                        class="profile"
                        style="margin-top: 10px"
                        color="grey"
                        size="150"
                        rounded
                      >
                        <v-img
                          v-if="dataItemHeader.empImageUrl"
                          :src="dataItemHeader.empImageUrl"
                        ></v-img> </v-avatar
                      ><br />
                    </center>
                    <v-col>
                      <v-card-text
                        ><v-icon color="#871B12">mdi-account-circle</v-icon
                        ><strong>ชื่อ-นามสกุล: </strong
                        >{{ dataItemHeader.empFull_NameTH }}
                      </v-card-text>
                      <v-card-text>
                        <v-icon color="#871B12">mdi-briefcase</v-icon>
                        <strong>หน่วยงาน: </strong
                        >{{ dataItemHeader.masDepartmentName }}
                      </v-card-text>
                      <v-card-text>
                        <v-icon color="#871B12">mdi-map-marker-radius</v-icon>
                        <strong>สาขา : </strong
                        >{{ dataItemHeader.masBranchName }}
                      </v-card-text>
                      <v-card-text
                        ><v-icon color="#871B12">mdi-account-box</v-icon
                        ><strong>รหัสพนักงาน : </strong
                        >{{ dataItemHeader.empCode }}</v-card-text
                      >
                      <v-card-text
                        ><v-icon color="#871B12"> mdi-cellphone-basic </v-icon
                        ><strong>เบอร์โทรศัพท์ : </strong
                        >{{ dataItemHeader.empTel }}</v-card-text
                      >
                      <v-card-text
                        ><v-icon color="#871B12"> mdi-email </v-icon
                        ><strong>อีเมล์ : </strong>{{ dataItemHeader.empEmail }}
                      </v-card-text>
                    </v-col>
                  </v-card>
                </v-col>
                <v-col
                  cols="4"
                  v-for="(itemsTeam, indexTeam) in dataItemTeam"
                  :key="indexTeam"
                >
                  <v-card elevation="2">
                    <v-toolbar color="#262A34" dark>
                      <v-toolbar-title>ทีมงาน</v-toolbar-title>
                    </v-toolbar>
                    <center>
                      <v-avatar
                        class="profile"
                        style="margin-top: 10px"
                        color="grey"
                        size="150"
                        rounded
                      >
                        <v-img
                          v-if="itemsTeam.empImageUrl"
                          :src="itemsTeam.empImageUrl"
                        ></v-img> </v-avatar
                      ><br />
                    </center>
                    <v-col>
                      <v-card-text
                        ><v-icon color="#871B12">mdi-account-circle</v-icon
                        ><strong>ชื่อ-นามสกุล: </strong
                        >{{ itemsTeam.empFull_NameTH }}
                      </v-card-text>
                      <v-card-text>
                        <v-icon color="#871B12">mdi-briefcase</v-icon>
                        <strong>หน่วยงาน: </strong
                        >{{ itemsTeam.masDepartmentName }}
                      </v-card-text>
                      <v-card-text>
                        <v-icon color="#871B12">mdi-map-marker-radius</v-icon>
                        <strong>สาขา : </strong>{{ itemsTeam.masBranchName }}
                      </v-card-text>
                      <v-card-text
                        ><v-icon color="#871B12">mdi-account-box</v-icon
                        ><strong>รหัสพนักงาน : </strong
                        >{{ itemsTeam.empCode }}</v-card-text
                      >
                      <v-card-text
                        ><v-icon color="#871B12"> mdi-cellphone-basic </v-icon
                        ><strong>เบอร์โทรศัพท์ : </strong
                        >{{ itemsTeam.empTel }}</v-card-text
                      >
                      <v-card-text
                        ><v-icon color="#871B12"> mdi-email </v-icon
                        ><strong>อีเมล์ : </strong>{{ itemsTeam.empEmail }}
                      </v-card-text>
                    </v-col>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import moment from 'moment' // แปลง date
import { gmapApi } from 'vue2-google-maps'
import monthNameTH from '../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../assets/master/Date/yearsNumber.json'

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile,
    moment,
    gmapApi
  },
  created () {
    setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      PK: '',
      center: {},
      session: this.$session.getAll(),
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        }
      ],
      tabs: 'tabInfo',
      date: '',
      profile: [],
      data: [],
      dataItem: [],
      dataItemTeam: [],
      dataItemHeader: [],
      dataByEmp: [],
      dataReportMonth: [],
      shifttem: [],
      events: [],
      disableBranch: true,
      disableDeparment: true,
      disableSearch: false,
      year: '',
      month: '',
      day: '',
      colorRisk: '',
      panel: [0, 1],
      startdate: this.getDateTh(),
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber
    }
  },
  async mounted () {
    await this.getGetToken()
    this.month = this.getMonthTh()
    let date = new Date()
    this.year = moment().format('YYYY')
    this.day = date.getDate()

    await this.getDataEmp()
  },
  methods: {
    async getDataEmp () {
      this.profile = JSON.parse(localStorage.getItem('data'))
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/employee/get?empCode=" + this.profile.empCode,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          this.profile = response.data[0]
          this.profile.empImageUrl =
            this.DNS_IP + '/' + this.profile.empImageUrl
          // console.log('profile', this.profile)
          // console.log('this.profile.empImageUrl', this.profile.empImageUrl)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })

      this.getDataToday()
      this.getCalendar()
      this.getEmployeeTeam()
      this.getEmployeeHeader()
      this.getReportCheckIN()
    },
    geolocate () {
      navigator.geolocation.getCurrentPosition((position) => {
        const center = {
          lat: parseFloat(position.coords.latitude),
          lng: parseFloat(position.coords.longitude)
        }
        this.center = center
        this.current.position = center
      })
    },
    async getDataToday () {
      this.dataItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import/get?empCode=' +
            this.profile.empCode +
            '&shiftMonth=' +
            this.getMonthThToINT(this.month) +
            '&shiftYear=' +
            this.year,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataItem = response.data
          this.dataItem.forEach((shifttem) => {
            if (shifttem.checkInStartStamp) {
              shifttem.colorout = 'green'

              // console.log('checkInStartStamp', shifttem.checkInStartStamp)
              // console.log('checkInEndStamp', shifttem.checkInEndStamp)
              // console.log('shifttem.leave', shifttem.leave)
              // console.log('shifttem.leave', shifttem.leaveSummaryDayName)

              if (!shifttem.checkInEndStamp) {
                shifttem.checkInEndStamp = 'ไม่พบข้อมูล'
                shifttem.checkOutDistance = 'ไม่พบข้อมูล'
                shifttem.colorout = '-'
              }

              if (shifttem.lateStatus === 'ปกติ') {
                shifttem.detail = 'ปกติ'
                shifttem.colorin = 'green'
              }

              if (shifttem.lateStatus === 'สาย') {
                shifttem.colorin = 'red'
                shifttem.detail = 'สาย'
              }

              if (shifttem.shiftCode === 'H') {
                shifttem.detail = 'วันหยุด'
              }
              if (shifttem.leave !== null) {
                shifttem.checkInStartStamp =
                  shifttem.leaveSummaryDayName === 'ครึ่งวันเช้า' ||
                  shifttem.leaveSummaryDayName === 'เต็มวัน'
                    ? shifttem.leave
                    : shifttem.checkInStartStamp
                shifttem.checkInEndStamp =
                  shifttem.leaveSummaryDayName === 'ครึ่งวันบ่าย' ||
                  shifttem.leaveSummaryDayName === 'เต็มวัน'
                    ? shifttem.leave
                    : shifttem.checkInEndStamp
                shifttem.colorin =
                  shifttem.leaveSummaryDayName === 'ครึ่งวันเช้า' ||
                  shifttem.leaveSummaryDayName === 'เต็มวัน'
                    ? 'blue'
                    : shifttem.colorin
                shifttem.colorout =
                  shifttem.leaveSummaryDayName === 'ครึ่งวันบ่าย' ||
                  shifttem.leaveSummaryDayName === 'เต็มวัน'
                    ? 'blue'
                    : shifttem.colorout
              }
            } else {
              if (shifttem.shiftCode === 'H') {
                shifttem.checkInStartStamp = 'วันหยุด'
                shifttem.checkInEndStamp = 'วันหยุด'
                shifttem.checkInDistance = 'วันหยุด'
                shifttem.checkInDistance = 'วันหยุด'
                shifttem.detail = 'วันหยุด'
                shifttem.colorin = 'black'
                shifttem.colorout = 'black'
              } else {
                if (shifttem.leave !== null) {
                  shifttem.checkInStartStamp =
                    shifttem.leaveSummaryDayName === 'ครึ่งวันเช้า' ||
                    shifttem.leaveSummaryDayName === 'เต็มวัน'
                      ? shifttem.leave
                      : 'ไม่พบข้อมูล'
                  shifttem.checkInEndStamp =
                    shifttem.leaveSummaryDayName === 'ครึ่งวันบ่าย' ||
                    shifttem.leaveSummaryDayName === 'เต็มวัน'
                      ? shifttem.leave
                      : 'ไม่พบข้อมูล'
                  shifttem.colorin =
                    shifttem.leaveSummaryDayName === 'ครึ่งวันเช้า' ||
                    shifttem.leaveSummaryDayName === 'เต็มวัน'
                      ? 'blue'
                      : '-'
                  shifttem.colorout =
                    shifttem.leaveSummaryDayName === 'ครึ่งวันบ่าย' ||
                    shifttem.leaveSummaryDayName === 'เต็มวัน'
                      ? 'blue'
                      : '-'
                } else {
                  shifttem.checkInStartStamp = 'วันหยุด'
                  shifttem.checkInEndStamp = 'วันหยุด'
                  shifttem.checkInDistance = 'วันหยุด'
                  shifttem.checkInDistance = 'วันหยุด'
                  shifttem.detail = 'ไม่พบข้อมูล'
                  shifttem.colorin = '-'
                  shifttem.colorout = '-'
                }
              }
            }
          })
          this.dataItem = this.dataItem
            .slice()
            .sort((a, b) => a.shiftDay - b.shiftDay)
          // this.getData()
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    async getCalendar () {
      this.events = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import/get?empCode=' +
            this.profile.empCode +
            '&shiftMonth=' +
            this.getMonthThToINT(this.month) +
            '&shiftYear=' +
            this.year
        )
        .then(async (response) => {
          response.data.forEach((elmShift) => {
            var dateFormat =
              elmShift.shiftYear +
              '-' +
              elmShift.shiftMonth +
              '-' +
              elmShift.shiftDay
            var dateFormatConvert = moment(String(dateFormat)).format(
              'YYYY-MM-DD'
            )
            this.startdate = dateFormatConvert
            this.events.push({
              name:
                elmShift.leave === null
                  ? elmShift.masShiftTypeName
                  : elmShift.leave,
              start: dateFormatConvert,
              color:
                elmShift.leave === null
                  ? elmShift.masShiftTypeColor
                  : '#2328c2'
            })
          })
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    async getEmployeeTeam () {
      this.dataItemTeam = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/employee/get?masDepartmentCode=' +
            this.profile.masDepartmentCode,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          this.dataItemTeam = response.data
          this.dataItemTeam.forEach((element) => {
            // console.log('getEmployeeTeam', element.empImageUrl)
            if (element.empImageUrl) {
              element.empImageUrl = this.DNS_IP + '/' + element.empImageUrl
              console.log('getEmployeeTeam', element.empImageUrl)
            }
          })
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    async getEmployeeHeader () {
      this.dataItemHeader = []
      if (this.profile.positionHeader) {
        await axios
          .get(
            // eslint-disable-next-line quotes
            this.DNS_IP +
              '/employee/get?positionCode=' +
              this.profile.positionHeader,
            {
              headers: {
                'Application-Key': localStorage.getItem('ApplicationKey')
              }
            }
          )
          .then(async (response) => {
            if (response.data[0].empImageUrl) {
              this.dataItemHeader.empImageUrl =
                this.DNS_IP + '/' + response.data[0].empImageUrl
            }
            this.dataItemHeader = response.data[0]
          })
          // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            console.log(error)
          })
      }
    },
    async getReportCheckIN () {
      // console.log('Report Check IN', this.profile.masBranchName)
      // console.log('Report Check IN', this.profile.masDepartmentName)
      // console.log('Report Check IN', this.profile.empCode)
      this.dataReportMonth = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import/reportMonthEmpCode?shiftMonth=' +
            this.getMonthThToINT(this.month) +
            '&shiftYear=' +
            this.year +
            '&empCode=' +
            this.profile.empCode,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          // console.log('getReportCheckIN', response.data)
          this.dataReportMonth = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReportMonth = []
          console.log(error)
        })
    },
    mapGetDataCheckIn (dt) {
      dt.forEach((shifttem) => {
        if (shifttem.checkInStartStamp) {
          var position = {
            lat: parseFloat(shifttem.checkInStartLat),
            lng: parseFloat(shifttem.checkInStartLong)
          }

          shifttem.iconIn =
            'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/marker%2Fin.png?alt=media'
          shifttem.positionIn = position
          this.center = position
        } else {
          shifttem.positionIn = position
        }
      })
    },
    mapGetDataCheckOut (dt) {
      dt.forEach((shifttem) => {
        if (shifttem.checkInEndStamp) {
          var position = {
            lat: parseFloat(shifttem.checkInEndLat),
            lng: parseFloat(shifttem.checkInEndLong)
          }

          shifttem.iconOut =
            'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/marker%2Fout.png?alt=media'
          shifttem.positionOut = position
          this.center = position
        } else {
          shifttem.positionOut = position
        }
      })
    },
    nextPage () {
      localStorage.setItem('CanEdit', true)
      localStorage.setItem('roll', 'Employee')
      localStorage.setItem('Page', '/Core/Home')
      this.$router.push('/HRM/Employee/EmployeeInfo')
    }
  }
}
</script>
<style scope>
.v-data-table-header {
  background-color: #262a34 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Core/Home.vue